export enum UserSubscriptionType {
  Clinic = 'clinic',
  Pro = 'pro',
  Free = 'free',
  Trial = 'trial',
  Premium = 'premium',
}
